module.exports = __webpack_public_path__ + "img/logo-perfect.a56ce2d3.png";